export default __webpack_public_path__ + "static/media/LAS0720.34I-37961_-22224_0.329660e9.jpg";